module.exports = __webpack_public_path__ + "img/vkontakte.d9c2dfe3.svg";